module.exports = __webpack_public_path__ + "static/media/logo_mtn.c3929d8e.svg";